module.exports = __webpack_public_path__ + "img/open_checkout.cd83e732.png";